var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollContainer",staticClass:"horizontal-scroll-container",style:({
  paddingLeft: _vm.paddingX + 'px',
  paddingRight: _vm.paddingX + 'px',
  height: _vm.wrapperHeight ? `${_vm.wrapperHeight}px` : 'auto'
})},[_c('button',{staticClass:"scroll-control-btn scroll-left-btn",attrs:{"disabled":!_vm.autoPlay && _vm.displayedItems.length === 0},on:{"click":_vm.scrollToPrevItem}},[_vm._v(" ‹ ")]),_c('div',{ref:"scrollViewport",staticClass:"horizontal-scroll-viewport",on:{"mouseenter":_vm.pauseAutoScroll,"mouseleave":_vm.resumeAutoScroll}},[_c('div',{staticClass:"horizontal-scroll-track",style:({ 
        transform: `translateX(${_vm.scrollPosition}px)`,
        gap: _vm.gap + 'px'
      })},_vm._l((_vm.displayedItems),function(item,idx){return _c('div',{key:idx,staticClass:"scroll-item",class:{ 
          'active-item': _vm.isActiveItem(idx),
          'prev-item': _vm.isPrevItem(idx),
          'next-item': _vm.isNextItem(idx) 
        },style:([ 
          { 
            flex: '0 0 auto', 
            width: _vm.itemWidth > 0 ? _vm.itemWidth + 'px' : 'auto',
            height: _vm.itemHeight > 0 ? _vm.itemHeight + 'px' : 'auto'
          },
          _vm.isActiveItem(idx) ? { transform: `scale(${_vm.activeScale})` } : {}
        ])},[_vm._t("default",null,{"item":item,"index":idx % _vm.items.length,"isClone":idx >= _vm.items.length})],2)}),0)]),_c('button',{staticClass:"scroll-control-btn scroll-right-btn",attrs:{"disabled":!_vm.autoPlay && _vm.displayedItems.length === 0},on:{"click":_vm.scrollToNextItem}},[_vm._v(" › ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }